import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import ExternalFile from 'external-files/ExternalFile';
import BaseEntryProtocolTabState, {
  EntryProtocolTabAttributes,
} from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';

export class ExternalEntryProtocolTabState extends BaseEntryProtocolTabState {
  override initialize(attrs: EntryProtocolTabAttributes, options?: {}): void {
    super.initialize(attrs, options);
    // Keep the external file backbone model in sync with the store.
    // Note: the view should use update handlers instead of directly manipulating the externalFile.
    this.set({
      externalFile: new ExternalFile(this.protocol()!.externalFile),
      owningEntityApiId: this.file().id,
    });
    this.listenTo(this.file(), 'change', () => {
      this.syncFromStore();
    });
    this.on('change:protocolCid', () => {
      this.syncFromStore();
    });
  }

  externalFile(): ExternalFile {
    return this.get('externalFile');
  }

  previewFile(): null {
    return null;
  }

  owningEntityApiId(): string {
    return this.get('owningEntityApiId');
  }

  updateName(name: string): void {
    this.updateProtocol({$merge: {name}});
  }

  updatePreviewType(previewType: EXTERNAL_FILE_TYPE): void {
    this.updateProtocol({externalFile: {$merge: {previewType}}});
  }

  syncFromStore(): void {
    this.externalFile().set(this.protocol()?.externalFile);
  }
}
